import layout from "../layout";

export default [
  {
    path: "/AdminSystem",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "",
        name: "login",
        component: () => import("@/pages/samples/auth-pages/login"),
        meta: {
          title: "AdminSystem",
        },
      },
      {
        path: "forget-password",
        name: "forget-password",
        component: () => import("@/SuperAdmin/forget_password"),
      },
      {
        path: "reset-password/:token",
        name: "reset-password",
        component: () => import("@/SuperAdmin/reset_passwords"),
      },
    ],
  },
  {
    path: "/AdminSystem",
    component: layout,
    children: [
      {
        path: "",
        name: "dashboard",
        component: () => import("@/SuperAdmin/dashboard"),
        meta: {
          title: "AdminSystem ||dashboard",
        },
      },
      {
        path: "rsvp_attendees",
        name: "rsvp_attendees",
        component: () => import("@/rsvp/rsvp_attendees"),
        meta: {
          title: "AdminSystem || RSVP Attendess",
        },
      },
      {
        path: "rsvp_calendar",
        name: "rsvp_calendar",
        component: () => import("@/rsvp/calendar"),
        meta: {
          title: "AdminSystem || Calendar",
        },
      },
      {
        path: "calendly_events",
        name: "admin_calendly_events",
        component: () => import("@/SuperAdmin/CalendlyEvents"),
        meta: {
          title: "AdminSystem || Calendly Availability",
        },
      },
      {
        path: "view_focus",
        name: "view_focus",
        component: () => import("@/web-content/focus/view_focus"),
        meta: {
          title: "AdminSystem || View Focus",
        },
      },
      {
        path: "edit_focus/:id",
        name: "edit_focus",
        component: () => import("@/web-content/focus/edit_focus"),
        meta: {
          title: "AdminSystem || Edit Focus",
        },
      },
      {
        path: "focus_action",
        name: "focus_action",
        component: () => import("@/web-content/focus/focus_action"),
        meta: {
          title: "AdminSystem || Focus action",
        },
      },

      {
        path: "resources_content",
        name: "resources_content",
        component: () => import("@/web-content/resources_content"),
        meta: {
          title: "AdminSystem || Resource Content",
        },
      },
      {
        path: "email_content",
        name: "email_content",
        component: () => import("@/web-content/email_content"),
        meta: {
          title: "AdminSystem ||Email content",
        },
      },
      {
        path: "register_content",
        name: "register_content",
        component: () => import("@/web-content/register_content"),
        meta: {
          title: "AdminSystem || Register content",
        },
      },
      {
        path: "contact_us_content",
        name: "contact_us_content",
        component: () => import("@/web-content/contact_us_content"),
        meta: {
          title: "AdminSystem || Contact us content",
        },
      },
      {
        path: "about_us_content",
        name: "about_us_content",
        component: () => import("@/web-content/about_us_content"),
        meta: {
          title: "AdminSystem || About us content",
        },
      },
      {
        path: "edit_home_video/:id",
        name: "edit_home_video",
        component: () => import("@/web-content/video/edit_home_video"),
        meta: {
          title: "AdminSystem || Edit Home page videos Content",
        },
      },
      {
        path: "homepage_videos",
        name: "homepage_videos",
        component: () => import("@/web-content/video/homepage_videos"),
        meta: {
          title: "AdminSystem || Home page videos Content",
        },
      },
      {
        path: "add_home_video",
        name: "add_home_video",
        component: () => import("@/web-content/video/add_home_video"),
        meta: {
          title: "AdminSystem || Add Home Video Content",
        },
      },
      {
        path: "privacy_policy",
        name: "privacy_policy",
        component: () => import("@/web-content/privacy_policy"),
        meta: {
          title: "AdminSystem || Edit Seminar Content",
        },
      },
      {
        path: "terms_of_service",
        name: "terms_of_service",
        component: () => import("@/web-content/terms_of_service"),
        meta: {
          title: "AdminSystem || Edit Seminar Content",
        },
      },
      {
        path: "subscribe_message",
        name: "subscribe_message",
        component: () => import("@/web-content/subscribe_message"),
        meta: {
          title: "AdminSystem || Edit Seminar Content",
        },
      },
      {
        path: "scott_message",
        name: "scott_message",
        component: () => import("@/web-content/scott_message"),
        meta: {
          title: "AdminSystem || Edit Seminar Content",
        },
      },
      {
        path: "seminar_content",
        name: "seminar_content",
        component: () => import("@/web-content/seminar_content"),
        meta: {
          title: "AdminSystem || Edit Seminar Content",
        },
      },
      {
        path: "webinar_content",
        name: "webinar_content",
        component: () => import("@/web-content/webinar_content"),
        meta: {
          title: "AdminSystem || Edit Webinar content",
        },
      },
      {
        path: "home_page_content",
        name: "home_page_content",
        component: () => import("@/web-content/home_page_content"),
        meta: {
          title: "AdminSystem || Edit Home page content",
        },
      },
      {
        path: "edit_document/:id",
        name: "edit_document",
        component: () => import("@/documents/edit_document"),
        meta: {
          title: "AdminSystem || Edit Document",
        },
      },
      {
        path: "archive_document",
        name: "archive_document",
        component: () => import("@/documents/archive_document"),
        meta: {
          title: "AdminSystem || Archive Document",
        },
      },
      {
        path: "view_document",
        name: "view_document",
        component: () => import("@/documents/view_document"),
        meta: {
          title: "AdminSystem || View Document",
        },
      },
      {
        path: "add_document",
        name: "add_document",
        component: () => import("@/documents/add_document"),
        meta: {
          title: "AdminSystem || Add Document",
        },
      },
      {
        path: "modules/:id",
        name: "custom_modules",
        component: () => import("@/semiar-items/modules"),
        meta: {
          title: "AdminSystem ||Custom module",
        },
      },
      {
        path: "view_seminar",
        name: "view_seminar",
        component: () => import("@/semiar-items/view_seminar"),
        meta: {
          title: "AdminSystem || View Seminar",
        },
      },
      {
        path: "add_seminar",
        name: "add_seminar",
        component: () => import("@/semiar-items/add_seminar"),
        meta: {
          title: "AdminSystem || Add Seminar",
        },
      },
      {
        path: "edit_seminar",
        name: "edit_seminar",
        component: () => import("@/semiar-items/edit_seminar"),
        meta: {
          title: "AdminSystem || Edit seminar",
        },
      },
      {
        path: "update_draft_email/:id",
        name: "updateDraftEmail",
        component: () => import("@/email-marketing/update_draft_email"),
        meta: {
          title: "AdminSystem || Drafted Email",
        },
      },
      {
        path: "view_email_template",
        name: "viewEmailTemplate",
        component: () => import("@/email-marketing/view_email_template"),
        meta: {
          title: "AdminSystem || Email Template",
        },
      },
      {
        path: "update_schedule_email/:id",
        name: "update_schedule_email",
        component: () => import("@/email-marketing/update_schedule_email"),
        meta: {
          title: "AdminSystem || Schedule Email",
        },
      },
      {
        path: "edit_Member/:id",
        name: "edit_Member",
        component: () => import("@/member/add_member"),
        meta: {
          title: "AdminSystem || Edit member",
        },
      },
      {
        path: "edit_Module/:id",
        name: "edit_Module",
        component: () => import("@/modules/editModules"),
        meta: {
          title: "AdminSystem || Edit Module",
        },
      },
      {
        path: "edit_webinarinfo/:id",
        name: "edit_webinarinfo",
        component: () => import("@/module/edit_webinarinfo"),
        meta: {
          title: "AdminSystem || Webinar Information",
        },
      },
      {
        path: "webinar_information",
        name: "webinar_information",
        component: () => import("@/module/webinar_information"),
        meta: {
          title: "AdminSystem || Webinar Information",
        },
      },
      {
        path: "Billing_details/:id",
        name: "Billing_details",
        component: () => import("@/member/Billing_details"),
        meta: {
          title: "AdminSystem ||Billing_details",
        },
      },
      {
        path: "survey_details/:userID/:surveyID",
        name: "survey_details",
        component: () => import("@/survey/survey_details"),
        meta: {
          title: "AdminSystem ||survey_details",
        },
      },
      {
        path: "add_member",
        name: "add_member",
        component: () => import("@/member/add_member"),
        meta: {
          title: "AdminSystem || Add member",
        },
      },
     
      {
        path: "add_survey",
        name: "add_survey",
        component: () => import("@/survey/add_survey"),
        meta: {
          title: "AdminSystem || Survey",
        },
      },
      {
        path: "edit_survey",
        name: "edit_survey",
        component: () => import("@/survey/edit_survey"),
        meta: {
          title: "AdminSystem || Survey",
        },
      },
      {
        path: "send_survey",
        name: "send_survey",
        component: () => import("@/survey/send_survey"),
        meta: {
          title: "AdminSystem || Survey",
        },
      },
      {
        path: "completed_survey",
        name: "completed_survey",
        component: () => import("@/survey/completed_survey"),
        meta: {
          title: "AdminSystem || Survey",
        },
      },
      {
        path: "preview_survey",
        name: "preview_survey",
        component: () => import("@/survey/preview_survey"),
        meta: {
          title: "AdminSystem || Survey",
        },
      },
      {
        path: "ViewMember",
        name: "ViewMember",
        component: () => import("@/member/ViewMember"),
        meta: {
          title: "AdminSystem || View Member",
        },
      },
      {
        path: "MemberFocuses",
        name: "MemberFocuses",
        component: () => import("@/member/MemberFocuses"),
        meta: {
          title: "AdminSystem ||Member Focuses",
        },
      },
      {
        path: "Position",
        name: "Position",
        component: () => import("@/member/Position"),
        meta: {
          title: "AdminSystem || Position",
        },
      },
      {
        path: "Status",
        name: "Status",
        component: () => import("@/member/Status"),
        meta: {
          title: "AdminSystem || Status",
        },
      },
      {
        path: "Billing",
        name: "Billing",
        component: () => import("@/member/Billing"),
        meta: {
          title: "AdminSystem || Billing",
        },
      },
      {
        path: "Transaction",
        name: "add_transaction",
        component: () => import("@/member/add_transaction"),
        meta: {
          title: "AdminSystem || Add transaction",
        },
      },
      {
        path: "File/download",
        name: "file_download",
        component: () => import("@/member/file_download"),
        meta: {
          title: "AdminSystem || File download",
        },
      },
      {
        path: "ViewReferrals",
        name: "ViewReferrals",
        component: () => import("@/referrals/ViewReferrals"),
        meta: {
          title: "AdminSystem || View Referrals",
        },
      },
      {
        path: "ViewModules",
        name: "ViewModules",
        component: () => import("@/modules/ViewModules"),
        meta: {
          title: "AdminSystem || View Modules",
        },
      },
      {
        path: "edit_Referrals/:id",
        name: "edit_Referrals",
        component: () => import("@/referrals/edit_Referrals"),
        meta: {
          title: "AdminSystem || Edit Referrals",
        },
      },
      {
        path: "ViewVendors",
        name: "ViewVendors",
        component: () => import("@/vendors/ViewVendors"),
        meta: {
          title: "AdminSystem || View Vendors",
        },
      },
      {
        path: "add_vendor",
        name: "add_vendor",
        component: () => import("@/vendors/add_vendor"),
        meta: {
          title: "AdminSystem || Add vendor",
        },
      },
      {
        path: "add_video",
        name: "add_video",
        component: () => import("@/videos/add_video"),
        meta: {
          title: "AdminSystem || Add video link",
        },
      },
      {
        path: "ViewVideos",
        name: "ViewVideos",
        component: () => import("@/videos/ViewVideos"),
        meta: {
          title: "AdminSystem || View Videos",
        },
      },
      {
        path: "ArchiveVideos",
        name: "ArchiveVideos",
        component: () => import("@/videos/ArchiveVideos"),
        meta: {
          title: "AdminSystem || Archive Videos",
        },
      },
      {
        path: "SeminarVideos",
        name: "SeminarVideos",
        component: () => import("@/videos/SeminarVideos"),
        meta: {
          title: "AdminSystem || Seminar Videos",
        },
      },
      {
        path: "edit_video/:id",
        name: "edit_video",
        component: () => import("@/videos/add_video"),
        meta: {
          title: "AdminSystem || edit video",
        },
      },
      {
        path: "edit_SeminarVideo/:id",
        name: "edit_SeminarVideo",
        component: () => import("@/videos/edit_SeminarVideo"),
        meta: {
          title: "AdminSystem || edit Seminar Video",
        },
      },
      {
        path: "edit_Vendor/:id",
        name: "edit_Vendor",
        component: () => import("@/vendors/add_vendor"),
        meta: {
          title: "AdminSystem || Edit vendor",
        },
      },

      {
        path: "ViewAwards",
        name: "ViewAwards",
        component: () => import("@/Awards/ViewAwards"),
        meta: {
          title: "AdminSystem || View vendor",
        },
      },
      {
        path: "add_awards",
        name: "add_awards",
        component: () => import("@/Awards/add_awards"),
        meta: {
          title: "AdminSystem || Add award",
        },
      },
      {
        path: "edit_Awards/:id",
        name: "edit_Awards",
        component: () => import("@/Awards/add_awards"),
        meta: {
          title: "AdminSystem || Edit award",
        },
      },
      {
        path: "webinar_scheduler",
        name: "webinar_scheduler",
        component: () => import("@/email-marketing/webinar_scheduler"),
        meta: {
          title: "AdminSystem || Webinar schedule",
        },
      },
      {
        path: "scheduling",
        name: "scheduling",
        component: () => import("@/email-marketing/scheduling"),
        meta: {
          title: "AdminSystem || Scheduling",
        },
      },
      {
        path: "draftedEmail",
        name: "draftedEmail",
        component: () => import("@/email-marketing/draftedEmail"),
        meta: {
          title: "AdminSystem || Drafted email",
        },
      },
      {
        path: "email_marketing",
        name: "email_marketing",
        component: () => import("@/email-marketing/email_marketing"),
        meta: {
          title: "AdminSystem || Eamil marketing",
        },
      },
      {
        path: "landing_page",
        name: "landing_page",
        component: () => import("@/email-marketing/landing_page"),
        meta: {
          title: "AdminSystem || Landing page",
        },
      },
      {
        path: "landing_page_view",
        name: "landing_page_view",
        component: () => import("@/email-marketing/landing_page_view"),
        meta: {
          title: "AdminSystem || view Landing page",
        },
      },
      {
        path: "email_list",
        name: "email_list",
        component: () => import("@/email-marketing/email_list"),
        meta: {
          title: "AdminSystem || Email list",
        },
      },
      {
        path: "email_history",
        name: "email_history",
        component: () => import("@/email-marketing/email_history"),
        meta: {
          title: "AdminSystem || Email list",
        },
      },
      {
        path: "email_list",
        name: "email_list",
        component: () => import("@/email-marketing/email_list"),
        meta: {
          title: "AdminSystem || Email list",
        },
      },
      {
        path: "email_management",
        name: "email_management",
        component: () => import("@/email-marketing/email_management"),
        meta: {
          title: "AdminSystem || Email management",
        },
      },
      {
        path: "settings",
        name: "settings",
        component: () => import("@/SuperAdmin/settings"),
        meta: {
          title: "AdminSystem || Settings",
        },
      },
      {
        path: "user/roles",
        name: "roles",
        component: () => import("@/SuperAdmin/roles"),
      },
      {
        path: "error-404",
        name: "error-404",
        component: () => import("@/custom-error/404"),
        meta: {
          title: "AdminSystem || 404",
        },
      },
      {
        path: "error-500",
        name: "error-500",
        component: () => import("@/pages/samples/error-pages/error-500"),
        meta: {
          title: "AdminSystem || 500",
        },
      },
      {
        path: "*",
        redirect: "error-404",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "error-404",
            // component: () => import("@/pages/samples/error-pages/error-404"),
          },
        ],
      },
    ],
  }
];
